var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.subTitle)}}),_vm._v(" "),_c('div',{staticClass:"page-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }